<!--
Created on Thu Jun 01 2023

Copyright (c) Cynnox, Inc - All Rights Reserved 2023 Jagan

Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential Written by Jagan <jagancpj246@gmail.com>, September 2020.
-->

<div class="d-flex flex-column align-items-center h-100">
  <div class="d-flex align-items-center justify-content-center flex-1">
    <div class="text-center" style="min-width: 300px">
      <img
        src="assets/logo/logo-name.png"
        height="180"
        width="180"
        style="margin-bottom: 10px"
      />

      @if (screenName == 'login_page') {
      <div>
        <h1 class="fw-bold">Delete Your Account</h1>
        <form #f="ngForm" (ngSubmit)="f.form.valid && onSubmitForm()">
          <div style="font-size: 12px; text-align: left; font-weight: 600">
            Please enter your details.
          </div>
          <div class="mb-1 mt-2">
            <input
              type="email"
              class="form-control"
              name="username"
              placeholder="Email"
              [(ngModel)]="username"
              #usernameField="ngModel"
              required
              (input)="errorMsg = ''"
            />
            @if (f.submitted && usernameField.invalid) {
            <div class="errorMsg">Please enter a valid email address</div>
            }
          </div>
          <div class="mb-1">
            <input
              type="password"
              class="form-control"
              name="password"
              placeholder="Password"
              [(ngModel)]="password"
              #passwordField="ngModel"
              required
              (input)="errorMsg = ''"
            />
            @if (f.submitted && passwordField.invalid) {
            <div class="errorMsg">Please enter a password</div>
            } @if (errorMsg) {
            <div class="errorMsg">
              {{ errorMsg }}
            </div>
            }
          </div>
          <button
            class="btn primary-bg w-100"
            type="submit"
            [disabled]="loading"
          >
            {{ loading ? "Please wait.." : "Continue" }}
          </button>
        </form>
      </div>
      } @if (screenName == 'confirm_pass') {
      <div>
        <div class="d-flex align-items-center profileContainer">
          <div class="letter">
            {{ getFirstLetter(loginResponse?.user?.firstName) }}
          </div>
          <div class="profileDetails">
            <div class="name">
              {{ loginResponse?.user?.firstName }}
              {{ loginResponse?.user?.lastName }}
            </div>
            <div class="email">{{ loginResponse?.user?.emailID }}</div>
          </div>
        </div>
        <form #df="ngForm" (ngSubmit)="df.form.valid && onDeleteUserAccount()">
          <div style="font-size: 12px; text-align: left; font-weight: 600">
            Please confirm your password to delete your account.
          </div>
          <div style="font-size: 12px; text-align: left; font-weight: 600">
            This action cannot be undone.
          </div>
          <div class="my-1">
            <input
              type="password"
              class="form-control"
              name="confirmPassword"
              placeholder="Confirm Password"
              [(ngModel)]="confirmPassword"
              #confirmPasswordField="ngModel"
              required
              (input)="errorMsg = ''"
            />
            @if (df.submitted && confirmPasswordField.invalid) {
            <div class="errorMsg">Please enter your password</div>
            } @if (errorMsg) {
            <div class="errorMsg">
              {{ errorMsg }}
            </div>
            }
          </div>
          <button
            class="btn btn-danger w-100"
            type="submit"
            [disabled]="loading"
          >
            {{ loading ? "Deleting..." : "Delete" }}
          </button>
        </form>
      </div>
      } @if (screenName == 'success_msg') {
      <div>
        <div class="profileContainer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style="height: 50px; width: 50px; fill: green"
          >
            <path
              d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
            />
          </svg>
          <h1 class="fw-bold">Account Deleted Successfully!!</h1>
        </div>
        <button
          class="btn primary-bg w-100"
          type="button"
          (click)="onGoBackPressed()"
          style="width: 300px !important"
        >
          {{ "Go To Home" }}
        </button>
      </div>
      }
    </div>
  </div>
</div>
